var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "patternmaker-patternmaker-view-body"
  }, [_c('div', {
    staticClass: "patternmaker-patternmaker-view-model-image"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.previewImageDataIsReady,
      expression: "!previewImageDataIsReady"
    }],
    staticClass: "patternmaker-patternmaker-view-spinner text-center"
  }, [_c('base-spinner', {
    attrs: {
      "size": _vm.spinnerSize,
      "position": "initial"
    }
  })], 1), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.previewImageUrl,
      expression: "previewImageUrl"
    }],
    attrs: {
      "src": _vm.previewImageUrl,
      "alt": _vm.translations.customPatternMakerTitle
    },
    on: {
      "load": function load($event) {
        return _vm.setPreviewImageIsLoading(false);
      }
    }
  })]), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    class: ['patternmaker-patternmaker-view-instructions', {
      'patternmaker-patternmaker-view-error': _vm.highligthSelectSwatchInstructions
    }]
  }, [_vm._v(_vm._s(_vm.translations.customCheckListInstructions))])]), _c('patternmaker-swatches-carousel', {
    attrs: {
      "swatches": _vm.swatches,
      "current-swatch": _vm.currentSwatch,
      "enabled": _vm.previewImageDataIsReady,
      "slide-to-selected-item": _vm.slideToSelectedItems
    },
    on: {
      "swatch-selected": _vm.selectSwatch
    }
  }), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    class: ['patternmaker-patternmaker-view-instructions', {
      'patternmaker-patternmaker-view-error': _vm.highligthSelectStickerInstructions
    }]
  }, [_vm._v(_vm._s(_vm.translations.customCheckListInstructions2))])]), _vm.enableStickerGroups ? _c('patternmaker-sticker-tabs', {
    attrs: {
      "tabs": _vm.stickerGroups
    }
  }) : _vm._e(), _c('patternmaker-stickers-carousel', {
    attrs: {
      "stickers": _vm.stickers,
      "current-sticker": _vm.currentSticker,
      "enabled": _vm.previewImageDataIsReady,
      "slide-to-selected-item": _vm.slideToSelectedItems
    },
    on: {
      "sticker-selected": _vm.selectSticker
    }
  }), _c('div', {
    staticClass: "row patternmaker-patternmaker-view-buttons-wrapper"
  }, [_c('div', {
    staticClass: "small-6 large-6 columns"
  }, [_c('button', {
    staticClass: "button secondary patternmaker-patternmaker-view-cta",
    attrs: {
      "type": "button",
      "disabled": !_vm.previewImageDataIsReady
    },
    on: {
      "click": function click($event) {
        return _vm.closeModalOption('cancel');
      }
    }
  }, [_vm._v(_vm._s(_vm.translations.customCheckCancel))])]), _c('div', {
    staticClass: "small-6 large-6 columns"
  }, [_c('button', {
    class: ['button primary patternmaker-patternmaker-view-cta', {
      disabled: !_vm.currentSwatch || !_vm.currentSticker || !_vm.previewImageDataIsReady
    }],
    attrs: {
      "type": "button",
      "disabled": !_vm.previewImageDataIsReady
    },
    on: {
      "click": function click($event) {
        return _vm.finish();
      }
    }
  }, [_vm._v(_vm._s(_vm.translations.customCheckFinish))])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }